import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom'
// import axios from 'axios';
import axiosInstance from '../token/axiosInstance';
import {connect} from 'react-redux';
import store from '../../redux/store';
import VerticalRuler from '../Ruler/VerticalRuler';
import HorizontalRuler from '../Ruler/HorizontalRuler';
import {Default} from '../Elements';
import TableElement from '../Elements/TableElement';
import ChartElement from '../Elements/ChartElement';
import objeler from '../objeler';
import html2canvas from '../../html2canvas/dist/html2canvas';
import './Editor.css';
import {confirm} from "../../components/Confirmation"
import {
    addToDragElements,
    addToDragElementsAll,
    addToScene,
    addToSceneBulk,
    changeProperties,
    changePropertiesById,
    changePropertiesById3,
    changePropertiesRange,
    dropElement,
    dropElementAll,
    dropElementBulk,
    makeElementActive,
    removeAllDragElements
} from '../../redux/actions';
import ModalDocParameters from './../ModalDocParameters';
import {CalcGridCoord, GetNewFileName, timeout, CleanDirect} from '../Functions/funcs';
import {inspectStructuredTableBindings, syncStructuredBindingForSave, syncTableBindingForSave} from '../Functions/structuredBinding';
import $ from 'jquery';
import download from 'downloadjs'
import {withAlert} from '../../react-alert-master/src'
import {SelectableGroup} from '../../react-selectable-master/src'
const cleanMessageText = 'Your changes will be lost. Are you sure you want to clean the document?';
const fs = require('fs');
const btnMenuItemClass = ' text-gray-600  hover:bg-blue-50    ';
const btnSubMenuItemClass = ' text-gray-600  hover:bg-blue-50  focus:text-gray-600 ';
const btnMenuTextClass = "text-sm text-gray-600";
const btnSubMenuClass = ' text-gray-600  bg-customWhite  hover:bg-blue-50  ';
const btnMenuIconSize = "1.1em";
const btnMenuIconWidth = "23px";
const btnMenuIconWidthPdf = "100%";

const btnMenuClass = 'inline-block bg-white  text-sm px-4 py-2 leading-none border rounded  text-gray-600 border-gray-600 hover:border-transparent  hover:bg-blue-500 hover:bg-text-red mt-1 lg:mt-2 ';
type Props = {
    showRuler?: string | boolean,
    width: 595,
    height: 842,
    scaleNumber: Number,
    objects?: {},
    addToScene: Function,
    removeAllDragElements: Function,
    dropElement: Function,
    dropElementBulk: Function,
    dropElementAll: Function,
    changeProperties: Function,
    changePropertiesById: Function,
    activeElement: {
        properties: { location: { x: number, y: number }, size: { w: number, h: number } }
    },
    makeElementActive: Functiony
};

class Editor extends Component<Props> {
    static defaultProps = {
        showRuler: true,
        objects: {}
    };

    constructor(props) {
        super(props);
        objeler['Editor'] = this;
        objeler['clearDocument'] = this.clearDocument;
        objeler['clearDocumentConfirm'] = this.clearDocumentConfirm;
        objeler['openConfirm'] = this.openDocumentConfirm;
        objeler['openDocDialogConfirm'] = this.openDocDialogConfirm;
        objeler['openPageDialogConfirm'] = this.openPageDialogConfirm;
        objeler['openDataDialogConfirm'] = this.openDataDialogConfirm;
        objeler['openPageDialog'] = this.openPageDialog;
        objeler['redir'] = this.redir;
        objeler['clipboardElement'] = null;
        this.editor = React.createRef();
        this.tooltipremove = React.createRef();
        objeler["tooltipremove"] = this.tooltipremove;
        this.SaveJSon = this.SaveJSon.bind(this);
        this.blobToBase64 = this.blobToBase64.bind(this);
        this.LoaderClose = this.LoaderClose.bind(this);
        this.onEndSelection = this.onEndSelection.bind(this);
        this.clearDocument = this.clearDocumentConfirm.bind(this);
        this.openDocument = this.openConfirm.bind(this);
        this.openDocDialog = this.openDocDialogConfirm.bind(this);
        this.openPageDialog = this.openPageDialogConfirm.bind(this);
        this.openDataDialog = this.openDataDialogConfirm.bind(this);
        this.clearDocument = this.clearDocumentConfirm.bind(this);
        this.state = {
            clipboardElement: null,
            offset: {x: 0, y: 0},
            offsetClick: {x: 0, y: 0},
            offsetEditorCopy: {x: 0, y: 0},
            offsetEditorPaste: {x: 0, y: 0},
        };
        const {alert} = this.props;

    }

    getBase64FromUrl = async (url) => {
        console.log("zzz", url)
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64data = reader.result;
                resolve(base64data);
            }
        });
    }

    async blobToBase64(blob) {
        console.log('tar', blob);
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }

    componentWillMount() {
        if (this.props.activePage == this.props.pageid)
            window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        if (this.props.activePage == this.props.pageid)
            window.removeEventListener('keydown', this.handleKeyDown);
    }

    saveScreenshot(canvas) {
        const fileName = "image";
        const link = document.createElement("a");
        link.download = fileName + ".png";
        console.log(canvas);
        var tt = canvas.toBlob(function (blob) {
            console.log(blob);
            link.href = URL.createObjectURL(blob);
            link.click();
            return blob;
        });
        console.log('tt', tt)
    }

    async screnShoot(callback, filename, pdf, e, p) {
        var edt = document.querySelectorAll('[rmeditor="1"]')[0];
        // console.log('EDT', edt);
        html2canvas(edt, {
            useCORS: true,
            taintTest: true,
            allowTaint: true,
            copyStyles: true,
            removeContainer: true,
            scale: 0.3
            ,
            onclone: function (clonedDoc) {
                var pr = clonedDoc.getElementById('zoomDiv');
                pr.style.transform = "";
                clonedDoc.getElementById('editor').classList.remove("GridLine");
                clonedDoc.querySelectorAll('[rmthumb]').forEach(e => e.remove());
                clonedDoc.querySelectorAll('.resizeHandlerWrapper.active').forEach(e => e.remove());
                // console.log("HTTTTTT");
            }
            ,
        }).then((canvas) => {
            const canvasBlob = new Promise(resolve => canvas.toBlob(resolve));
            canvasBlob.then(function (blob) {
                // console.log('canvasBlob')
                // console.log(blob)
                callback(filename, pdf, e, p, blob);
                return blob;
            }, function (err) {
                console.log(err)
            }).then((r) => {
            });
        })
        return;
    }

    async screenShotHtml(callback, filename, pdf, e, p, cshtml) {
        var edt = document.querySelectorAll('[rmeditor="1"]')[0];
        console.log('EDT', edt);
        var items = edt.querySelectorAll('[rmimg="1"]');
        html2canvas(edt, {
            useCORS: true,
            taintTest: true,
            allowTaint: true,
            copyStyles: true,
            removeContainer: true,
            scale: 0.3
            ,
            onclone: async function (clonedDoc) {
                var pr = clonedDoc.getElementById('zoomDiv');
                pr.style.transform = "";
                clonedDoc.getElementById('editor').classList.remove("GridLine");
                clonedDoc.querySelectorAll('[rmthumb]').forEach(e => e.remove());
                clonedDoc.querySelectorAll('.resizeHandlerWrapper').forEach(e => e.remove());
                clonedDoc.querySelectorAll('.topAndBottom').forEach(e => e.remove());
                clonedDoc.querySelectorAll('.leftAndRight').forEach(e => e.remove());
                clonedDoc.querySelectorAll('.handler').forEach(e => e.remove());
                console.log("HTTTTTT");
                for (const src in items) {
                    console.log("H 1");
                    if (items[src].currentSrc != undefined) {
                        var blobUrl = items[src].currentSrc;
                        console.log(blobUrl);
                        const data = await fetch(blobUrl);
                        const blob = await data.blob();
                        console.log("zzz", blob)
                        var tt = await new Promise((resolve) => {
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onloadend = () => {
                                const base64data = reader.result;
                                resolve(base64data);
                            }
                        });
                        items[src].src = tt;
                        var itm = clonedDoc.getElementById(items[src].id)
                        var prn = itm.parentElement.parentElement;
                        itm.src = tt;
                        var sz = prn.style.width;
                        itm.style.visibility = "visible";
                        itm.style.width = prn.style.width;
                        itm.style.height = prn.style.height;
                        console.log('BLOB', items[src].id);
                    }
                }
                var drg = clonedDoc.querySelectorAll('.draggable,.draggableNoBox')
                // console.log('DRG', store.getState().appReducers.objects);
                var htm = "<!DOCTYPE html>\n<html>\n<body style=\"margin:0;\">\n"
                if (objeler.ModalDocParameters.IsScript)
                    htm += "<head>\n" + objeler.ModalDocParameters.Script + "\n</head>\n"
                var htmend = "<body/>\n<html/>"
                for (const dr in drg) {
                    if (drg[dr].outerHTML == undefined) continue
                    var obj = store.getState().appReducers.objects;
                    var objs = Object.keys(obj).map(key => obj[key]);
                    var scr = objs.find(a => a.ObjName == drg[dr].id);
                    var prefix = ""
                    if (scr != undefined) {
                        if (scr.properties.IsScript && scr.properties.Script != "") {
                            htm += "\n" + scr.properties.Script + "\n{\n" + drg[dr].outerHTML + "\n}\n";
                        } else {
                            htm += "\n" + drg[dr].outerHTML;
                        }
                    }
                }
                htm += htmend;
                var aaa = clonedDoc.getElementById('editor').outerHTML;
                console.log(aaa);
                console.log(htm)
                let utf8Encode = new TextEncoder();
                var byteArray = utf8Encode.encode(clonedDoc.getElementById('editor'));
                const htmlblob = new Blob([htm], {type: 'text/html'});
                console.log(htmlblob);
                const link = document.createElement("a");
                link.download = filename + ".html";
                if (cshtml)
                    link.download = filename + ".cshtml";
                link.href = URL.createObjectURL(htmlblob);
                link.click();
            }
            ,
        }).then((canvas) => {
            const canvasBlob = new Promise(resolve => canvas.toBlob(resolve));
            canvasBlob.then(function (blob) {
                console.log('canvasBlob')
                console.log(blob)
                callback(filename, pdf, e, p, blob);
                return blob;
            }, function (err) {
                console.log(err)
            }).then((r) => {
            });
        })
        return;
    }

    getElementTransform = (id) => {
        var tar = document.getElementById(id).style.transform.replace("translate(", "").replace(")", "").replace(" ", "").replace("px", "").replace("px", "").split(",");
        return {
            x: parseFloat(tar[0]),
            y: parseFloat(tar[1])
        }
    }
    handleKeyDown = (e) => {
        if (this.props.IsModalOpen) return;
        const {
            activeElement,
            changeProperties,
            changePropertiesById3,
            addToDragElementsAll,
            changePropertiesRange,
            addToDragElements,
            removeAllDragElements
        } = this.props;
        if (e.keyCode == 65 && e.ctrlKey) {
            e.stopPropagation();
            e.preventDefault()
            removeAllDragElements();
            const objects = store.getState().appReducers.objects;
            addToDragElementsAll(this.props.activePage);
            return;
            for (let prop in objects) {
                if (
                    objects[prop].PageId == this.props.activePage
                ) {
                    addToDragElements(objects[prop]);
                }
            }
            return;
        }
        const objects = store.getState().appReducers.dragElements;
        if (activeElement == null && objects.length == 0) return;
        if (e.keyCode < 37 || e.keyCode > 40) return;
        e.stopPropagation();
        e.preventDefault()
        var sz = 1;
        if (this.props.EditorProps.ShowGridLines)
            sz = this.props.GridSize / 1;
        if (objects.length > 0) {
            var stop = false;
            const {makeElementActive} = this.props;
            for (let prop in objects) {
                var tar = this.getElementTransform(objects[prop].id);
                var x = tar.x;
                var y = tar.y;
                switch (e.keyCode) {
                    case 37:
                        x = x - sz;
                        break;
                    case 38:
                        y = y - sz;
                        break;
                    case 39:
                        x = x + sz;
                        break;
                    case 40:
                        y = y + sz;
                        break;
                }
                if (x < 0) {
                    x = 0;
                    stop = true;
                    return;
                }
                if (y < 0) {
                    y = 0;
                    stop = true;
                    return;
                }
                if (x + objects[prop].properties.size.width > this.props.page.width) {
                    x = this.props.page.width - objects[prop].properties.size.width;
                    stop = true;
                    return;
                }
                if (y + objects[prop].properties.size.height > this.props.page.height) {
                    y = this.props.page.height - objects[prop].properties.size.height;
                    stop = true;
                    return;
                }
            }
            if (!stop) {
                for (let prop in objects) {
                    var tar = this.getElementTransform(objects[prop].id);
                    var x = tar.x;
                    var y = tar.y;
                    switch (e.keyCode) {
                        case 37:
                            x = x - sz;
                            break;
                        case 38:
                            y = y - sz;
                            break;
                        case 39:
                            x = x + sz;
                            break;
                        case 40:
                            y = y + sz;
                            break;
                    }
                    if (x < 0) x = 0;
                    if (y < 0) y = 0;
                    if (x + objects[prop].properties.size.width > this.props.page.width)
                        x = this.props.page.width - objects[prop].properties.size.width;
                    if (y + objects[prop].properties.size.height > this.props.page.height)
                        y = this.props.page.height - objects[prop].properties.size.height;
                    objects[prop].properties.location.x = x;
                    objects[prop].properties.location.y = y;
                }
                changePropertiesRange(objects);
            }
        } else {
            var x = activeElement.properties.location.x;
            var y = activeElement.properties.location.y;
            var width = activeElement.properties.size.width;
            var height = activeElement.properties.size.height;
            var ratio = -1;
            if (activeElement.properties.BarcodeType == 'QR') {
                ratio = activeElement.properties.size.width / activeElement.properties.size.height;
            }
            if (!e.shiftKey)
                switch (e.keyCode) {
                    case 37:
                        x = x - sz;
                        break;
                    case 38:
                        y = y - sz;
                        break;
                    case 39:
                        x = x + sz;
                        break;
                    case 40:
                        y = y + sz;
                        break;
                }
            else
                switch (e.keyCode) {
                    case 37:
                        width = width - sz;
                        if (ratio > -1) height = width * ratio;
                        break;
                    case 38:
                        height = height - sz;
                        if (ratio > -1) width = height * ratio;
                        break;
                    case 39:
                        width = width + sz;
                        if (ratio > -1) height = width * ratio;
                        break;
                    case 40:
                        height = height + sz;
                        if (ratio > -1) width = height * ratio;
                        break;
                }
            ratio = -1;
            if (x < 0) x = 0;
            if (y < 0) y = 0;
            if (x + activeElement.properties.size.width > this.props.page.width)
                x = this.props.page.width - activeElement.properties.size.width;
            if (y + activeElement.properties.size.height > this.props.page.height)
                y = this.props.page.height - activeElement.properties.size.height;
            changeProperties({
                location: {
                    x: x,
                    y: y
                }
                ,
                size: {
                    width: width,
                    height: height
                }
            });
        }
    }

    componentDidMount() {
        objeler["tooltipremove"] = this.tooltipremove;
    }

    componentDidUpdate() {
        this.scrollToBottom();
        objeler["tooltipremove"] = this.tooltipremove;
        if (objeler.User !== null && objeler.User.hasOwnProperty("Origin") && objeler.User.Origin == "Direct") {
            objeler.User.Origin = undefined
            let search = window.location.search;
            let params = new URLSearchParams(search);
            // console.log('this.props.location.state',this.props.location)


            if (this.props.location.state.hasOwnProperty('filename')) {
                // console.log('FORMDATA', this.props.location.state.filename);

                // let filename = params.get('filename');
                let filename = this.props.location.state.filename
                delete this.props.location.state.filename
                // console.log('TTTT', filename)
                this.OpenDocOk(filename, true).then((response) => {
                    // console.log('RESPONSE', response)
                    if (!response)
                        objeler.User = null

                })
            }
            else {
                // alert(66)
                sessionStorage.clear();
                objeler.User = null;
                this.props.history.push({
                    pathname: '/Direct'
                    , state: {redir: true}
                })

            }

        }
    }

    scrollToBottom() {
    }

    ContextMenuClose() {
        this.setState({isContextMenuOpen: false, ContextMenuState: 'closed'})
    }

    componentDidMount() {
        this.scrollToBottom();
        $.ajaxTransport("+binary", function (options, originalOptions, jqXHR) {
            if (window.FormData && ((options.dataType && (options.dataType == 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob))))) {
                return {
                    send: function (_, callback) {
                        alert(777);
                        var xhr = new XMLHttpRequest(),
                            url = options.url,
                            type = options.type,
                            dataType = options.responseType || "blob",
                            data = options.data || null;
                        xhr.addEventListener('load', function () {
                            var data = {};
                            data[options.dataType] = xhr.response;
                            callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
                        });
                        xhr.open(type, url, true);
                        xhr.responseType = dataType;
                        xhr.send(data);
                    },
                    abort: function () {
                        jqXHR.abort();
                    }
                };
            }
        });
    }

    getFileToDownload(apiUrl) {
        return axiosInstance.get(apiUrl, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }

    base64ToArrayBuffer(base64) {
        var binaryString = $.window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    async SaveJSoncap(filename, pdf, e, p) {
        this.props.ShowLoader(true, ['Please wait...', 'Saving...']);
        this.screnShoot(this.SaveJSon, filename, pdf, e, p);
        return;
    }

    async SaveJSoncapHtml(filename, pdf, e, p, cshtml) {
        this.props.ShowLoader(true, ['Please wait...', 'Saving...']);
        this.screenShotHtml(this.SaveJSon, filename, pdf, e, p, cshtml);
        return;
    }

    async LoaderClose() {
        this.props.ShowLoader(false, ['']);
        this.props.ShowLoaderAllClose();
    }

    async SaveJSon(filename, pdf, e, p, thumbnail) {
        const {alert} = this.props;
        var frmCount = 0;
        const data = new FormData();
        this.ReOrganiseZIndex(e);
        for (let prop in e) {
            if (e[prop].properties.JpgFileName != "") {
                let blob = await fetch(e[prop].properties.JpgBlob).then(r => r.blob());
                data.append('file', blob);
                data.append('filename', e[prop].properties.JpgFileName);
                frmCount = frmCount + 1;
            }
            if (e[prop].properties.CertFileName != "") {
                let certblob = await fetch(e[prop].properties.CertBlob).then(r => r.blob());
                data.append('file', certblob);
                data.append('filename', e[prop].properties.CertFileName);
                frmCount = frmCount + 1;
            }
        }
        if (objeler.ModalDocParameters.OleDbFile != "") {
            let datablob = await fetch(objeler.ModalDocParameters.OleDbFileBlob).then(r => r.blob());
            datablob = datablob.slice(0, datablob.size, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel");
            data.append('file', datablob);
            data.append('filename', objeler.ModalDocParameters.OleDbFile);
            frmCount = frmCount + 1;
        }
        data.append('file', thumbnail);
        data.append('filename', '.thumbnail');
        frmCount = frmCount + 1;
        thumbnail
        if (objeler.ModalDocParameters.DataProvider == "OleDb") {
            objeler.ModalDocParameters.ConnectionString = objeler.ModalDocParameters.ConnectionStringTemplate.replace("~datafile~", objeler.ModalDocParameters.OleDbFile);
            objeler.ModalDocParameters.ConnectionString = objeler.ModalDocParameters.ConnectionString.replace("~publicfolder~", process.env.REACT_APP_PUBLIC + "/" + process.env.REACT_APP_USERS + "/" + objeler.User.Email + "/" + filename);
        }
        // Normalize Table elements: sync root ↔ properties before saving
        e && Object.keys(e).forEach(key => {
            e[key] = syncStructuredBindingForSave(e[key]);
        });
        e && Object.keys(e).forEach(key => {
            e[key] = syncTableBindingForSave(e[key]);
        });
        const structuredTableAudit = inspectStructuredTableBindings(e);
        console.log(
            `[STRUCT-SAVE] tableElements=${structuredTableAudit.tableElementCount} ` +
            `boundTables=${structuredTableAudit.boundTableCount}`
        );
        structuredTableAudit.tables.forEach(table => {
            console.log(
                `[STRUCT-SAVE] table=${table.key} kind=${table.kind || 'none'} ` +
                `rowsPath=${table.rowsPath || 'none'} root=${table.atRoot} properties=${table.atProperties}`
            );
        });
        // Migrate old "black" BorderColor to "#000000" before saving
        e && Object.keys(e).forEach(key => {
            if (e[key].type === 'Table' && e[key].properties?.BorderColor === 'black') {
                console.log(`🔧 Pre-save migration: ${key} BorderColor "black" → "#000000"`);
                e[key].properties.BorderColor = '#000000';
            }
        });
        
        // Log what's being saved
        console.log('💾 SAVING DOCUMENT:', filename);
        console.log('💾 Objects being saved:', e);
        e && Object.keys(e).forEach(key => {
            if (e[key].type === 'Table') {
                console.log(`💾 Table ${key} BorderColor:`, e[key].properties?.BorderColor);
                console.log(`💾 Table ${key} DataSource (root):`, e[key].DataSource);
                console.log(`💾 Table ${key} DataSource (properties):`, e[key].properties?.DataSource);
                console.log(`💾 Table ${key} Bound:`, e[key].properties?.Bound);
                console.log(`💾 Table ${key} IsDynamic:`, e[key].properties?.IsDynamic);
                console.log(`💾 Table ${key} ColumnMapping:`, e[key].ColumnMapping);
            }
        });
        
        data.append('objects', JSON.stringify(e));
        data.append('pages', JSON.stringify(p));
        data.append('jsonfilename', filename);
        data.append('pdf', pdf);
        data.append('doc', JSON.stringify(objeler.ModalDocParameters));
        data.append('user', objeler.User.Email);
        data.append('password', objeler.User.Password);
        await axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/wdc/save', data
            , {
                // headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`},
                responseType: 'arraybuffer'
            }
        ).then((response) => {
            switch (response.status) {
                case 200:
                    objeler.ModalFileParameters.FileName = filename;
                    objeler.DocName = objeler.ModalFileParameters.FileName;
                    if (pdf) {
                        alert.success([{type: "success", msg: "Document saved.",}, {
                            type: "success",
                            msg: "PDF file created.",
                        }]);
                        const content = response.headers['content-type'];
                        var extension = ".pdf";
                        if (objeler.ModalDocParameters.OleDbFile !== "")
                            extension = (objeler.ModalDocParameters.ItemCountPerDoc == "0" ? ".pdf" : ".zip");
                        download(response.data, filename + extension, content)
                    } else
                        alert.success([{type: "success", msg: "Document saved."}]);
                    break;
                case 201:
                    objeler.ModalFileParameters.FileName = filename;
                    objeler.DocName = objeler.ModalFileParameters.FileName;
                    alert.success([{type: "success", msg: "Document saved.",}, {
                        type: "error",
                        msg: "PDF file has not been created."
                    }]);
                    break;
                case 205:
                    alert.success([{type: "error", msg: "Document could not be saved."}]);
                    break;
                case 210:
                    var enc = new TextDecoder("utf-8");
                    alert.success([{type: "error", msg: "PDF file has not been created."}]);
                    const content = response.headers['content-type'];
                    download(response.data, filename + "_error.txt", content)
                    break;
            }
            this.props.RefreshFileExplorer();
            if (pdf) {
            } else {
            }
        }).catch(function (error) {
            alert.show('Unable to connect to server.Try again later.', true, {
                title: "Nerwork Error",
                closeCopy: "OK"
            });
            if (error.response) {
                switch (error.response.status) {
                    case 450:
                        alert.show('Wrong password of certificate file', true, {
                            title: "Nerwork Error",
                            closeCopy: "OK"
                        });
                        break;
                }
            }
        });
        this.props.ShowLoader(false, ['']);
        this.props.ShowLoaderAllClose();
        return;
        await axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/wdc/save/' + filename, e);
        return;
        axios({
            url: window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/wdc/' + e,
            method: 'GET',
            params: {json: e},
            responseType: 'text',
        }).then((response) => {
            alert(7777);
        }).catch(error => {
            alert(error)
        });
        ;
    }

    ResetLocation() {
        const {objects} = this.props;
        for (let prop in objects) {
            objects[prop].properties.location.fx = 0;
            objects[prop].properties.location.fy = 0;
        }
    }

    Obj2Json(obj) {
        var x = 0;
        const len = Object.keys(obj).length
        var ret = '"elements":[';
        for (let prop in obj) {
            x = x + 1;
            ret = ret + JSON.stringify(obj[prop]);
            if (x < len)
                ret = ret + ',';
        }
        ret = ret + ']';
        return ret;
    }

    Json2Obj(str) {
        const tool = JSON.parse(str);
    }

    hasStructuredBinding(objects) {
        const visit = (value) => {
            if (!value || typeof value !== 'object') return false;
            const binding = value.binding || (value.properties && value.properties.binding);
            if (binding && ['scalar', 'image', 'table'].includes(String(binding.kind || '').toLowerCase())) {
                return true;
            }
            if (Array.isArray(value)) return value.some(visit);
            return Object.keys(value).some(key => visit(value[key]));
        };
        return visit(objects);
    }

    hasStructuredJsonSample() {
        const sample =
            (objeler.ModalDocParameters && objeler.ModalDocParameters.StructuredJsonSample) ||
            (objeler.ModalDocValues && objeler.ModalDocValues.StructuredJsonSample);
        return !!(sample && sample.valid && sample.json);
    }

    Save(filename, pdf) {
        const objects = store.getState().appReducers.objects;
        const pages = store.getState().appReducers.Pages;
        if (pdf && this.hasStructuredBinding(objects) && !this.hasStructuredJsonSample()) {
            const {alert} = this.props;
            alert.show('Structured JSON sample is required for preview PDF export. Open document properties and upload the Beko JSON sample first.', true, {
                title: 'Preview data required',
                closeCopy: 'OK'
            });
            return;
        }
        var myJsonString = JSON.stringify(this.props.objects);
        this.SaveJSoncap(filename, pdf, objects, pages);
        return;
    }

    SaveHtml(filename, cshtml) {
        const objects = store.getState().appReducers.objects;
        const pages = store.getState().appReducers.Pages;
        var myJsonString = JSON.stringify(this.props.objects);
        this.SaveJSoncapHtml(filename, false, objects, pages, cshtml);
        return;
    }

    async openDataDialogConfirm() {
        objeler.openModalData();
    }

    async openDocDialogConfirm() {
        objeler.openModalDoc();
    }

    async openPageDialogConfirm(e) {
        objeler.ModalPageParameters = objeler.GetActivePage(e);
        objeler.openModalPage();
    }

    async openConfirm() {
        if (await confirm("Silmek istediğinizden emin misiniz?")) {
            this.clearDocument2();
            this.props.ScrollReset();
            this.props.ResetPage();
            objeler.ModalFileParameters = ({Type: 'Open', Title: 'Open File', FileName: objeler.DocName});
            objeler.openModalFile();
        }
    }

    focus() {
        setTimeout(() => {
            this.editor.focus();
        }, 100);
    }

    CleanOk() {
        this.props.ScrollReset();
        this.clearDocument2();
        this.props.ResetPage();
        objeler.ModalDocParameters = {...ModalDocParameters};
        objeler.ModalFileParameters.IsNew = 1;
        objeler.ModalFileParameters.FileName = GetNewFileName();
        objeler.DocName = objeler.ModalFileParameters.FileName;

    }

    CleanOkDirect(filename) {
        this.props.ScrollReset();
        this.clearDocument2();
        this.props.ResetPage();
        objeler.ModalDocParameters = {...ModalDocParameters};
        objeler.ModalFileParameters.IsNew = 1;
        objeler.ModalFileParameters.FileName = filename;
        objeler.DocName = objeler.ModalFileParameters.FileName;

        console.log(2222222)
    }

    Clean(e) {
        const {alert} = this.props;
        alert.success(cleanMessageText, true
            , {
                title: "Warning",
                closeCopy: "Cancel",
                actions: [
                    {
                        copy: "OK",
                        onClick: () => {
                            this.CleanOk()
                        },
                    }
                ]
            }
        );
    }

    CleanDirect(filename) {
        this.CleanOkDirect(filename)
    }

    async OpenDocOk(filename, isnew) {
        // console.log('TARIK', filename)
        this.clearDocument2();
        this.props.ScrollReset();
        this.props.ResetPage();
        if (filename == undefined) {
            objeler.ModalFileParameters = ({Type: 'Open', Title: 'Open File', FileName: objeler.DocName});
            objeler.openModalFile();
        } else {
            objeler.openModalFile(true);
            let ret = await objeler.Editor.Open(filename, isnew)
            // console.log('TARIK', ret)
            objeler.ModalDocParameters.FileName = null
            objeler.ModalFileParameters.FileName = null;
            return ret
        }
    }

    OpenDoc(filename) {
        const {alert} = this.props;
        alert.success(cleanMessageText, true
            , {
                title: "Warning",
                closeCopy: "Cancel",
                actions: [
                    {
                        copy: "OK",
                        onClick: () => {
                            this.OpenDocOk(filename, false)
                        },
                    }
                ]
            }
        );
    }

    async clearDocumentConfirm() {
        if (await confirm("Silmek istediğinizden emin misiniz?")) {
            this.clearDocument();
            return true;
        }
        return false;
    }

    openDocument = (e) => {
        alert("opens");
    }
    clearDocument = (e) => {
        const {dropElement, dropElementAll, objects} = this.props;
        dropElementAll();
        objeler.ModalFileParameters.IsNew = 1;
        objeler.ModalFileParameters.FileName = GetNewFileName();
        objeler.DocName = objeler.ModalFileParameters.FileName;
    }
    clearDocument2 = (e) => {
        const objects = store.getState().appReducers.objects;
        const {dropElement, dropElementAll} = this.props;
        dropElementAll();
    }

    redir() {
        localStorage.clear();
        objeler.User = null;
        this.props.history.push({
            pathname: '/'
            , state: {redir: true}
        })
    }

    async Open(filename, isnew) {
        // isnew = false
        await timeout(300);
        const {alert} = this.props;
        var hatavar = false;

        const username = objeler.User.Email;
        const password = objeler.User.password;
        const access_token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64');
        var loadObjects;
        var loadPages;
        this.props.ShowLoader(true, ['Please wait...', 'Loading...']);
        const url = window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/wdc/open/' + username + '/' + filename;
        await axiosInstance.get(url
            , {
            // headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`}
        }
        ).then(resp => {
            if (resp.status != 200) {
                hatavar = true;
                if (!isnew) {
                    alert.success([{type: "error", msg: "Document not found."}]);
                    this.props.ShowLoader(false, ['']);
                }
            } else {
                // console.log('ZZZZZ', resp.data)
                if (resp.data.doc === null) {
                    hatavar = true;
                    if (!isnew) {
                        alert.success([{type: "error", msg: "Document not found."}]);
                        objeler.ModalFileParameters.FileName = filename;
                        objeler.DocName = objeler.ModalFileParameters.FileName;
                        this.props.ShowLoader(false, ['']);
                    }
                } else {
                    objeler.DocName = filename;
                    loadObjects = JSON.parse(resp.data.objects);
                    loadPages = JSON.parse(resp.data.pages);
                    objeler.ModalDocParameters = JSON.parse(resp.data.doc);
                    
                    // Migrate old "black" BorderColor to "#000000" on load
                    loadObjects && Object.keys(loadObjects).forEach(key => {
                        if (loadObjects[key].type === 'Table' && loadObjects[key].properties?.BorderColor === 'black') {
                            console.log(`🔧 Load-time migration: ${key} BorderColor "black" → "#000000"`);
                            loadObjects[key].properties.BorderColor = '#000000';
                        }
                    });
                    
                    // Log what's being loaded
                    console.log('📂 LOADING DOCUMENT:', filename);
                    console.log('📂 Objects loaded:', loadObjects);
                    loadObjects && Object.keys(loadObjects).forEach(key => {
                        if (loadObjects[key].type === 'Table') {
                            console.log(`📂 Table ${key} BorderColor:`, loadObjects[key].properties?.BorderColor);
                        }
                    });
                    
                    if (objeler.ModalDocParameters.DataSource === undefined)
                        objeler.ModalDocParameters.DataSource = [];
                    objeler.ModalDocParameters.OleDbFileBlob = window.GET_API_URL(process.env.REACT_APP_SERVICE) + "/api/wdc/download/" + objeler.User.Email + "/" + objeler.DocName + "/" + objeler.ModalDocParameters.OleDbFile;
                }
            }
        })
            .catch((error) => {
                hatavar = true;
                console.log('HATA0', error)
                try {
                    if (error.response.status == 401) {
                        objeler.User = null;
                        this.props.history.push({
                            pathname: '/'
                            , state: {redir: true}
                        })
                    }
                } catch (err) {
                    this.props.ShowLoader(false, ['']);
                    alert.show('Unable to connect to server.Try again later.', true, {
                        title: "Nerwork Error",
                        closeCopy: "OK"
                    });
                    this.props.ShowLoaderAllClose();
                    return false;
                }
                this.props.ShowLoader(false, ['']);
                return false;
            });
        // console.log("ddddddd", hatavar, isnew);
        if (hatavar) {

            if (isnew) {

                CleanDirect(filename)
                this.props.ShowLoader(false, ['']);

                return true

            } else {
                this.props.ShowLoader(false, ['']);
                return false;
            }
            X

        }


        let oleBlob = await fetch(objeler.ModalDocParameters.OleDbFileBlob
            , {
            headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`}
        }
        )
            .then(r => r.blob());
        objeler.ModalDocParameters.OleDbFileBlob = URL.createObjectURL(oleBlob);
        objeler.App.LoadPage(loadPages);
        ;
        const {addToScene, addToSceneBulk, dropElement, removeAllDragElements} = this.props;
        const tool = loadObjects;
        var t;
        removeAllDragElements();
        for (let prop in loadObjects) {
            loadObjects[prop].properties.JpgPath = window.GET_API_URL(process.env.REACT_APP_SERVICE) + "/api/wdc/download/" + objeler.User.Email + "/" + objeler.DocName + "/" + loadObjects[prop].properties.JpgFileName;
            loadObjects[prop].properties.JpgBlob = "";
            let jblob = await fetch(loadObjects[prop].properties.JpgPath
                , {headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`}}
            )
                .then(r => r.blob());
            loadObjects[prop].properties.JpgBlob = URL.createObjectURL(jblob);
            if (loadObjects[prop].type == 'Signature') {
                loadObjects[prop].properties.CertBlob = window.GET_API_URL(process.env.REACT_APP_SERVICE) + "/api/wdc/download/" + objeler.User.Email + "/" + objeler.DocName + "/" + loadObjects[prop].properties.CertFileName;
                let certBlob = await fetch(loadObjects[prop].properties.CertBlob
                    , {headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`}}
                )
                    .then(r => r.blob());
                loadObjects[prop].properties.CertBlob = URL.createObjectURL(certBlob);
            }
        }
        addToSceneBulk(loadObjects);
        this.props.ShowLoader(false, ['']);
        objeler.ModalFileParameters.IsNew = 0;
        return true
    }

    CreateUniqueId() {
        var id = 1;
        if (Object.keys(this.props.objects).length != 0)
            id = 1 + Math.max.apply(Math, Object.values(this.props.objects).map(function (o) {
                return o.ObjName.replace("element_", "");
            }))
        if (this.props.objects[id] == undefined)
            return id;
        else
            return this.CreateUniqueId();
    }

    onDragOver = e => {
        e.preventDefault();
    }

    Sil(e) {
    }

    onDrop = e => {
        const tool = JSON.parse(e.dataTransfer.getData('tool'));
        if (tool.hasOwnProperty("Explorer")) {
            this.OpenDoc(tool.Name)
            return;
        }
        const {addToScene, objects, alert} = this.props;
        if (tool.type === "Signature")
            for (let prop in objects) {
                if (objects[prop].type == "Signature") {
                    alert.success([{type: "info", msg: "Multiple signatures cannot be added."}]);
                    return;
                }
            }
        var x = 0;
        if (e.clientX - e.currentTarget.getBoundingClientRect().left - (50 * objeler.scale) < 0)
            x = 0;
        else
            x = e.clientX - e.currentTarget.getBoundingClientRect().left - (50 * objeler.scale) + tool.properties.location.x;
        var y = 0;
        if (e.clientY - e.currentTarget.getBoundingClientRect().top - (10 * objeler.scale) < 0)
            y = 0;
        else
            y = e.clientY - e.currentTarget.getBoundingClientRect().top - (10 * objeler.scale) + tool.properties.location.y;
        x = x / objeler.scale;
        y = y / objeler.scale;
        if (x + tool.properties.size.width > this.props.width)
            x = x - (x + tool.properties.size.width - this.props.width);
        if (y + tool.properties.size.height > this.props.height)
            y = y - (y + tool.properties.size.height - this.props.height);
        const id = this.CreateUniqueId();
        const objname = 'element_' + id;
        const objzindex = id * 100;
        var w = tool.properties.size.width;
        var h = tool.properties.size.height;
        if (this.props.EditorProps.ShowGridLines) {
            x = CalcGridCoord(this.props.GridSize, x, true);
            y = CalcGridCoord(this.props.GridSize, y, true);
            w = CalcGridCoord(this.props.GridSize, tool.properties.size.width, true);
            h = CalcGridCoord(this.props.GridSize, tool.properties.size.height, true);
        }
        if (w == 0)
            w = this.props.GridSize;
        if (h == 0)
            h = this.props.GridSize;
        var fw = Math.floor(w);
        var fh = Math.floor(h);
        var dw = w - fw;
        var dh = h - fh;
        if (dw != 0)
            w = fw + 0.5;
        if (dh != 0)
            h = fh + 0.5;
        
        // Set default properties for Table elements
        let elementProperties = {
            ...tool.properties,
            Text: tool.title,
            Zindex: objzindex,
            location: {
                x: x,
                y: y,
                fx: x,
                fy: y
            },
            size: {
                width: w,
                height: h
            }
        };
        
        // Add Table-specific defaults if not already set
        if (tool.type === 'Table') {
            elementProperties = {
                ...elementProperties,
                BorderColor: elementProperties.BorderColor === 'black' ? '#000000' : (elementProperties.BorderColor || '#000000'),
                BorderWidth: elementProperties.BorderWidth || 1,
                BorderStyle: elementProperties.BorderStyle || 'Solid',
                Fill: elementProperties.Fill || false,
                FillColor: elementProperties.FillColor || '#ffffff',
                HasHeader: elementProperties.HasHeader !== undefined ? elementProperties.HasHeader : true,
                HeaderHeight: elementProperties.HeaderHeight || 30,
                RowHeight: elementProperties.RowHeight || 25,
                ZebraStripe: elementProperties.ZebraStripe || false,
                AlternateColor: elementProperties.AlternateColor || '#f5f5f5',
                Mode: elementProperties.Mode || 'Manual',
                TableData: elementProperties.TableData || []
            };
        }

        // FIX-CHART: Add Chart-specific defaults
        if (tool.type === 'Chart') {
            elementProperties = {
                ...elementProperties,
                ChartType: elementProperties.ChartType || 'Bar',
                Mode: elementProperties.Mode || 'Manual',
                Bound: elementProperties.Bound || false,
                DataSource: elementProperties.DataSource || '',
                CategoryField: elementProperties.CategoryField || '',
                ValueField: elementProperties.ValueField || '',
                Title: elementProperties.Title || '',
                ShowLegend: elementProperties.ShowLegend !== undefined ? elementProperties.ShowLegend : false,
                ShowValues: elementProperties.ShowValues !== undefined ? elementProperties.ShowValues : true,
                ShowGrid: elementProperties.ShowGrid !== undefined ? elementProperties.ShowGrid : true,
                ShowAxisLabels: elementProperties.ShowAxisLabels !== undefined ? elementProperties.ShowAxisLabels : true,
                BarColor: elementProperties.BarColor || '#3182CE',
                ColorPalette: elementProperties.ColorPalette || [],
                TitleFontSize: elementProperties.TitleFontSize || 12,
                LabelFontSize: elementProperties.LabelFontSize || 8,
                YAxisMin: elementProperties.YAxisMin || 'auto',
                YAxisMax: elementProperties.YAxisMax || 'auto',
                ChartData: elementProperties.ChartData || [
                    { label: 'Ocak', value: 120 },
                    { label: 'Şubat', value: 180 },
                    { label: 'Mart', value: 140 },
                    { label: 'Nisan', value: 220 }
                ]
            };
        }

        addToScene(objname, {
            type: tool.type,
            content: tool.title,
            jpg: "",
            ObjName: objname,
            PageId: this.props.pageid,
            properties: elementProperties,
            id: objname
        });
    };
    onSelectEditor = e => {
        const {makeElementActive} = this.props;
        if (e.target.classList.contains('editor') || e.target.classList.contains('page')) {
            makeElementActive(null);
        }
    };

    rulerX() {
        const {showRuler, activeElement, width} = this.props;
        const isX = typeof showRuler === 'string' && showRuler.toLocaleLowerCase() === 'x';
        return showRuler === true || isX ? (
            <HorizontalRuler
                followerW={activeElement ? activeElement.properties.size.width : null}
                followerX={activeElement ? activeElement.properties.location.x : null}
                width={width}
            />
        ) : null;
    }

    rulerY() {
        const {showRuler, activeElement, height} = this.props;
        const isY = typeof showRuler === 'string' && showRuler.toLocaleLowerCase() === 'y';
        return showRuler === true || isY ? (
            <VerticalRuler
                followerH={activeElement ? activeElement.properties.size.height : null}
                followerY={activeElement ? activeElement.properties.location.y : null}
                height={height}
            />
        ) : null;
    }

    onClick(t) {
        t.content = "sfdsdfs";
        alert("fff");
    };

    onTableHeader(t) {

        const dragElements = store.getState().appReducers.dragElements;
        console.log("dragElements", dragElements)
        let sortedArr = dragElements.sort((a, b) => a.properties.location.x - b.properties.location.x)
        console.log("wholeArray", sortedArr)
        var y = -1
        var h = -1
        var x = -1
        var tableName = ""
        for (let prp in sortedArr) {
            console.log("wholeArray", sortedArr[prp])
            if (y === -1) {
                y = sortedArr[prp].properties.location.y
                x = sortedArr[prp].properties.location.x
                h = sortedArr[prp].properties.size.height
                tableName = sortedArr[prp].properties.Table.Name
                if (tableName === "") {
                    tableName = "table" + sortedArr[prp].ObjName.replace("element_", "")
                    console.log("tableName22", tableName)
                }
            } else {
                sortedArr[prp].properties.location.y = y
                sortedArr[prp].properties.location.x = x
                sortedArr[prp].properties.size.height = h
            }
            x += sortedArr[prp].properties.size.width
            sortedArr[prp].properties.IsTable = true
            sortedArr[prp].properties.Table.Type = "Header"
            sortedArr[prp].properties.Table.Name = tableName
        }

    };

    onTableRow(t) {

        const dragElements = store.getState().appReducers.dragElements;
        console.log("dragElements", dragElements)
        let sortedArr = dragElements.sort((a, b) => a.properties.location.x - b.properties.location.x)
        console.log("wholeArray", sortedArr)
        var y = -1
        var h = -1
        var x = -1
        var tableName = ""
        var ind = 0;
        for (let prp in sortedArr) {
            ind++
            if (sortedArr[prp].properties.Table.Type === "Header") {
                if (ind === 1) {
                    tableName = sortedArr[prp].properties.Table.Name;
                    y = sortedArr[prp].properties.location.y + sortedArr[prp].properties.size.height
                    x = sortedArr[prp].properties.location.x
                    if (tableName === "") {
                        tableName = "table" + sortedArr[prp].ObjName.replace("element_", "")
                    }
                }
                continue;
            }
            console.log("wholeArray", sortedArr[prp])
            if (y === -1) {
                y = sortedArr[prp].properties.location.y
                x = sortedArr[prp].properties.location.x
                h = sortedArr[prp].properties.size.height

                if (sortedArr[prp].properties.Table.Name === "" || tableName === "") {
                    tableName = "table" + sortedArr[prp].ObjName.replace("element_", "")
                    console.log("tableName22", tableName)
                }
            } else {
                sortedArr[prp].properties.location.y = y
                sortedArr[prp].properties.location.x = x
                sortedArr[prp].properties.size.height = h
            }
            x += sortedArr[prp].properties.size.width
            sortedArr[prp].properties.IsTable = true
            sortedArr[prp].properties.Table.Type = "Row"
            sortedArr[prp].properties.Table.Name = tableName
        }

    };

    onTableRowr(t) {

        alert("fff");
    };

    onAddColumn(insert) {
        // console.log('COLL', this.props.activeElement.properties.Coord)
        if (this.props.activeElement == null) return;
        if (this.props.activeElement.properties.Coord == undefined) return;

        for (var i = 0; i < this.props.activeElement.properties.TableData.length; ++i) {
            console.log('this.props.activeElement.properties.TableData', this.props.activeElement.properties.TableData[i])
            if (!insert)
                this.props.activeElement.properties.TableData[i].Cells.push({...defaultCell})
            else
                this.props.activeElement.properties.TableData[i] = [
                    ...this.props.activeElement.properties.TableData[i].Cells.slice(0, this.props.activeElement.properties.Coord.c),
                    {...defaultCell},
                    ...this.props.activeElement.properties.TableData[i].Cells.slice(this.props.activeElement.properties.Coord.c)
                ];

        }
    }

    onMerge(insert) {
        console.log('Coord', this.props.activeElement.properties.Coord, this.props.activeElement.properties.SelectedCells)
        if (this.props.activeElement == null) return;
        if (this.props.activeElement.properties.Coord == undefined) return;
        if (this.props.activeElement.properties.SelectedCells === undefined || this.props.activeElement.properties.SelectedCells.length < 2) return;
        let i = this.props.activeElement.properties.Coord.r
        console.log('Coord', this.props.activeElement.properties.SelectedCells)
        let objsorted = this.props.activeElement.properties.SelectedCells.sort((a, b) => a.c - b.c)
        console.log('objsorted', objsorted)
        let totalWidth = 0
        for (let t = 1; t < objsorted.length; t++) {
            totalWidth += this.props.activeElement.properties.TableData[i].Cells[objsorted[t].c].w
        }

        this.props.activeElement.properties.TableData[i].Cells.splice(objsorted[1].c, objsorted.length - 1)

        // this.props.activeElement.properties.TableData[i] = [
        //     ...this.props.activeElement.properties.TableData[i].slice(0, this.props.activeElement.properties.Coord.c),
        //     {
        //         "v": "",
        //         "c": "",
        //         "span":1
        //     },
        //     ...this.props.activeElement.properties.TableData[i].slice(this.props.activeElement.properties.Coord.c)
        // ];
        this.props.activeElement.properties.TableData[i].Cells[objsorted[0].c].span += objsorted.length - 1;
        // this.props.activeElement.properties.TableData[i][objsorted[0].c].w += totalWidth;
        console.log('SPAN', this.props.activeElement.properties.TableData[i].Cells[objsorted[0].c], objsorted[0].c)
    }

    onUnMerge(insert) {

        if (this.props.activeElement == null) return;
        if (this.props.activeElement.properties.Coord == undefined) return;

        let i = this.props.activeElement.properties.Coord.r
        let objsorted = this.props.activeElement.properties.SelectedCells.sort((a, b) => a.c - b.c)
        let mx = Math.max(...this.props.activeElement.properties.TableData.map(o => o.Cells.length))
        console.log('MAX', mx, this.props.activeElement.properties.TableData[i].length)
        //for (let ii = 0; ii <= (mx-this.props.activeElement.properties.TableData[i].length); ii++) {
        let len = this.props.activeElement.properties.TableData[i].Cells.length
        for (let f = 0; f < (mx - len); f++) {
            this.props.activeElement.properties.TableData[i].Cells.push({...defaultCell})
            console.log('ff', f)
        }
        this.props.activeElement.properties.TableData[i].Cells[this.props.activeElement.properties.Coord.c].span = 1
        // this.props.activeElement.properties.TableData[i][objsorted[0].c].w += defaultCell.w;


    }

    onDeleteColumn() {

        if (this.props.activeElement == null) return;
        if (this.props.activeElement.properties.Coord == undefined) return;
        if (this.props.activeElement.properties.TableData[0].length < 2) return;

        for (var i = 0; i < this.props.activeElement.properties.TableData.length; ++i) {
            console.log('this.props.activeElement.properties.TableData', this.props.activeElement.properties.TableData[i])

            this.props.activeElement.properties.TableData[i].Cells.splice(this.props.activeElement.properties.Coord.c, 1)
        }
    }

    onAddRow(insert) {

        if (this.props.activeElement == null) return;
        if (this.props.activeElement.properties.Coord == undefined) return;
        let rw = {Cells: [], Embed: defaultEmbed}
        for (var i = 0; i < this.props.activeElement.properties.TableData[0].Cells.length; ++i) {
            rw.Cells.push({...defaultCell})
        }
        if (!insert)
            this.props.activeElement.properties.TableData.push(rw)
        else
            this.props.activeElement.properties.TableData = [
                ...this.props.activeElement.properties.TableData.slice(0, this.props.activeElement.properties.Coord.r),
                rw,
                ...this.props.activeElement.properties.TableData.slice(this.props.activeElement.properties.Coord.r)
            ];

    }

    onDeleteRow() {

        if (this.props.activeElement == null) return;
        if (this.props.activeElement.properties.Coord == undefined) return;
        if (this.props.activeElement.properties.TableData.length < 2) return;

        this.props.activeElement.properties.TableData.splice(this.props.activeElement.properties.Coord.r, 1)
    }

    setSendtoBack_old(objects, id) {
        var ind = 100000000;
        var obj;
        for (let prp in objects) {
            if (ind > objects[prp].properties.Zindex) {
                ind = objects[prp].properties.Zindex;
                obj = prp
            }
        }
        const {changeProperties, changePropertiesById, changePropertiesRange} = this.props;
        const zind = objects[id].properties.Zindex;
        changeProperties({Zindex: objects[obj].properties.Zindex});
        changePropertiesById(obj, {Zindex: zind});
    }

    setBringToFront(objects, id, direction) {
        this.ReOrganiseZIndex(objects);
        const {changePropertiesById} = this.props;
        for (let prp in objects) {
            if (prp != id) {
                if (
                    (objects[prp].properties.Zindex < objects[id].properties.Zindex && direction == -1)
                    ||
                    (objects[prp].properties.Zindex > objects[id].properties.Zindex && direction == 1)
                )
                    objects[prp].properties.Zindex = (objects[prp].properties.Zindex - (direction * 100));
                if (objects[prp].properties.Zindex <= 0 || objects[prp].properties.Zindex > Object.keys(objects).length * 100)
                    alert('hata ' + prp + ' ' + objects[prp].properties.Zindex)
            }
        }
        var zind = 100;
        if (direction > 0)
            zind = Object.keys(objects).length * 100;
        changePropertiesById(id, {Zindex: zind});
        const bbb = store.getState().appReducers.objects;
    }

    setBringToFrontMulti_old(objects, drags, len) {
        var l = Object.keys(objects).length - len;
        const {changePropertiesById} = this.props;
        var ind = 0;
        for (let prp in objects) {
            if (drags.hasOwnProperty(prp))
                ind = (objects[prp].properties.Zindex + (l * 100));
            else
                ind = (objects[prp].properties.Zindex - (len * 100));
        }
    }

    nestedSort = (prop1, prop2 = null, direction = 'asc') => (e1, e2) => {
        const a = prop2 ? e1[prop1][prop2] : e1[prop1],
            b = prop2 ? e2[prop1][prop2] : e2[prop1],
            sortOrder = direction === "asc" ? 1 : -1
        return (a < b) ? -sortOrder : (a > b) ? sortOrder : 0;
    }

    setBringToFrontMulti(objects, drags) {
        var start = 100;
        const {changePropertiesById} = this.props;
        let wholeArray = Object.keys(objects).map(key => objects[key]);
        wholeArray.sort(this.nestedSort("properties", "Zindex"));
        for (let prp in wholeArray) {
            if (!drags.hasOwnProperty(wholeArray[prp].id)) {
                objects[wholeArray[prp].id].properties.Zindex = start;
                start = start + 100;
            }
        }
        wholeArray = Object.keys(drags).map(key => drags[key]);
        wholeArray.sort(this.nestedSort("properties", "Zindex"));
        for (let prp in wholeArray) {
            drags[wholeArray[prp].id].properties.Zindex = start;
            start = start + 100;
        }
        return;
        for (let prp in objects) {
            if (!drags.hasOwnProperty(prp)) {
                objects[prp].properties.Zindex = start;
                start = start + 100;
            }
        }
        for (let prp in drags) {
            drags[prp].properties.Zindex = start;
            start = start + 100;
            console.log(prp)
        }
    }

    ReOrganiseZIndex(objects) {
        var start = 100;
        let wholeArray = Object.keys(objects).map(key => objects[key]);
        wholeArray.sort(this.nestedSort("properties", "Zindex"));
        for (let prp in wholeArray) {
            objects[wholeArray[prp].id].properties.Zindex = start;
            start = start + 100;
        }
    }

    setBringToFront2(objects, id) {
        var ind = 0;
        var obj;
        for (let prp in objects) {
            if (ind < objects[prp].properties.Zindex) {
                ind = objects[prp].properties.Zindex;
                obj = prp
            }
        }
        const {changeProperties, changePropertiesById} = this.props;
        const zind = objects[id].properties.Zindex;
        changePropertiesById(id, {Zindex: objects[obj].properties.Zindex});
        changePropertiesById(obj, {Zindex: zind});
    }

    onBringToFront(e) {
        if (this.props.activeElement == null) return;
        const {objects} = this.props;
        this.setBringToFront(objects, this.props.activeElement.id, 1);
        return;
    }

    onSendToBack(e) {
        if (this.props.activeElement == null) return;
        const {objects} = this.props;
        this.setBringToFront(objects, this.props.activeElement.id, -1);
        return;
    }

    onCopy(e, cut) {
        if (this.props.activeElement == null) return;
        var footerText = "";
        footerText = this.props.activeElement.type + ' (' + this.props.activeElement.ObjName + ')';
        this.setState({
                clipboardElement: this.props.activeElement,
                offsetEditorCopy: {
                    x: this.editor.getBoundingClientRect().x,
                    y: this.editor.getBoundingClientRect().y
                },
                offset: this.state.offsetClick
            },
            () => {
                this.props.clipboardContainerElement({
                    ...this.props.clipboardContainerElementValue,
                    scaleNumber: this.props.scaleNumber,
                    footerText: footerText,
                    element: this.props.activeElement,
                    fx: this.props.AnchorPoint.x - this.props.activeElement.properties.location.x,
                    fy: this.props.AnchorPoint.y - this.props.activeElement.properties.location.y,
                    offsetEditorCopy: {
                        x: this.editor.getBoundingClientRect().x,
                        y: this.editor.getBoundingClientRect().y
                    },
                    offset: this.state.offsetClick
                });
                if (cut) {
                    const {dropElement} = this.props;
                    dropElement(this.state.clipboardElement.ObjName);
                }
            });
    }

    onPaste(e) {
        if (this.props.clipboardContainerElementValue.element == null) return;
        const obj = this.props.clipboardContainerElementValue.element;
        console.log("obj", obj.type);
        const {addToScene, objects} = this.props;
        var existsObj = false;
        for (let prop in objects) {
            if (objects[prop].ObjName == obj.ObjName) {
                existsObj = true;
                break;
            }
        }
        var objname;
        var objzindex;
        if (existsObj) {
            const id = this.CreateUniqueId();
            objname = 'element_' + id;
            objzindex = id * 100;
        } else {
            objname = obj.ObjName;
            objzindex = obj.properties.Zindex;
        }
        var edt = document.querySelector('[rmeditor="' + this.props.MenuActionPageId + '"]');
        var x = this.props.AnchorPoint.x - edt.getBoundingClientRect().left - 0;
        var y = this.props.AnchorPoint.y - edt.getBoundingClientRect().top - 0;
        console.log('TTTTTTTT', this.props.AnchorPoint.y, edt.getBoundingClientRect().top, this.props.MenuActionPageId)
        x = x / (this.props.scaleNumber);
        y = y / (this.props.scaleNumber);
        if (x + this.props.clipboardContainerElementValue.element.properties.size.width > this.props.width) {
            x = x - (x + this.props.clipboardContainerElementValue.element.properties.size.width - this.props.width);
            console.log('cccc')
        }
        console.log('yyy', y, this.props.clipboardContainerElementValue.element.properties.size.height, this.props.height)
        if (y + this.props.clipboardContainerElementValue.element.properties.size.height > this.props.height) {
            y = y - (y + this.props.clipboardContainerElementValue.element.properties.size.height - this.props.height);
        }
        console.log('paste', y)
        addToScene(objname, {
            type: obj.type,
            content: obj.content,
            jpg: obj.jpg,
            jpgPath: obj.jpgPath,
            ObjName: objname,
            PageId: this.props.MenuActionPageId,
            properties: {
                ...obj.properties
                , Zindex: objzindex
                , location: {
                    x: x,
                    y: y
                }
            },
            id: objname
        });
    }

    setEditorClientPos(e) {
        console.log('ContextMenuState', this.props.ContextMenuState)
        this.props.setContextMenuState('closed');
        const {removeAllDragElements} = this.props;
        console.log('GUVEN pg', store.getState().appReducers.Pages);
        console.log('GUVEN', store.getState().appReducers.objects);
        console.log('GUVEN DataSource', objeler.ModalDocParameters.DataSource);
        console.log('GUVEN DataSource', JSON.stringify(objeler.ModalDocParameters.DataSource));
        removeAllDragElements();
        this.props.clipboardContainerElement(
            {
                ...this.props.clipboardContainerElementValue,
                EditorMouseDown: true,
                offsetEditorPaste: {
                    x: this.editor.getBoundingClientRect().x,
                    y: this.editor.getBoundingClientRect().y
                }
            }
        );
        this.setState(
            {
                offsetEditorPaste: {
                    x: this.editor.getBoundingClientRect().x,
                    y: this.editor.getBoundingClientRect().y
                }
            },
            () => {
            });
    }

    setElementClientPos(e) {
        this.props.clipboardContainerElement({
            ...this.props.clipboardContainerElementValue,
            EditorMouseDown: false,
            offsetClick: {
                x: e.clientX - e.currentTarget.getBoundingClientRect().x,
                y: e.clientY - e.currentTarget.getBoundingClientRect().y
            }
        });
        this.setState(
            {
                offsetClick: {
                    x: e.clientX - e.currentTarget.getBoundingClientRect().x,
                    y: e.clientY - e.currentTarget.getBoundingClientRect().y
                }
            },
            () => {
            });
    }

    onEndSelection(e) {
        const objects = store.getState().appReducers.objects;
        const {addToDragElements, addToDragElementsAll, activeElement, makeElementActive} = this.props;
        addToDragElementsAll(this.props.pageid, e);
        const drags = store.getState().appReducers.dragElements;
        const abc = Object.keys(drags)
            .reduce((obj, key) => {
                obj[[drags[key].id]] = drags[key];
                return obj;
            }, {});
        this.setBringToFrontMulti(objects, abc);
        return;
        for (let prop in objects) {
            if (
                objects[prop].properties.location.x > e.boxLeft
                && objects[prop].properties.location.y > e.boxTop
                && objects[prop].properties.location.x + objects[prop].properties.size.width < e.boxLeft + e.boxWidth
                && objects[prop].properties.location.y + objects[prop].properties.size.height < e.boxTop + e.boxHeight
                && objects[prop].PageId == this.props.pageid
            ) {
                addToDragElements(objects[prop]);
            }
        }
    }

    render() {
        const menuScale = () => {
            var z = Math.round((1 / this.props.scaleNumber) * 100) / 100;
            return 'scale(' + z + ',' + z + ')';
        };
        const {objects} = this.props;
        let paneNumber;
        if (this.props.pages.length > 1 && this.props.EditorProps.ShowPageNumber)
            paneNumber = <p className="page" id="pagenumber" rmthumb="1">{this.props.pageid} </p>
        if (objeler.User == null) {
            return <Redirect to="/"/>;
        }
        const selected = store.getState().appReducers.activeElement;
        const dragElements = store.getState().appReducers.dragElements;
        return (
            <div className="w-full flex flex-1 justify-between"
                 ref={this.props.tarik}
                 id={"editorContainer" + this.props.pageid}
            >
                <div
                    ref={abc => this.editor = abc}
                    id="editorp"
                    onClickCapture={this.onSelectEditor}
                    onDragOver={e => this.onDragOver(e)}
                    onDrop={e => this.onDrop(e)}
                    className="editor-wrapper"
                    onMouseDown={(e) => {
                        this.setEditorClientPos(e);
                    }}
                    onMouseEnter={(e) => {
                        this.props.onMouseEnter(this.props.pageid)
                    }}
                >
                    <SelectableGroup
                        onEndSelection={this.onEndSelection}
                        enabled={selected == null && dragElements.length == 0}
                        scaleNumber={parseFloat(this.props.scaleNumber)}
                    >
                        <div
                            className={`editor ${this.props.EditorProps.ShowGridLines ? 'GridLine' : ''}`}
                            id="editor" rmeditor={this.props.pageid}
                            onMouseMove={(e) => {
                                this.props.onMouseMove(e)
                            }}
                            onMouseDown={(e) => {
                                this.props.onMouseDown(e)
                            }}
                            onMouseUp={(e) => {
                                this.props.onMouseUp(e)
                            }}
                            style={
                                {
                                    marginLeft: '0',
                                    marginTop: '0',
                                    width: this.props.page.width,
                                    height: this.props.page.height,
                                }}
                            onContextMenu={e => {
                                e.preventDefault();
                                this.props.setMenuActionPageId(this.props.pageid);
                                this.props.setAnchorPoint({x: e.clientX, y: e.clientY});
                                this.props.setContextMenuState('opening');
                            }}>
                            {this.props.EditorProps.ShowRuler && this.rulerX()}
                            {this.props.EditorProps.ShowRuler && this.rulerY()}
                            {/* FIX-MP-FOOTER-CFG: Footer zone visual indicator — dashed line
                                at Y = pageHeight - FooterZoneHeight. Elements below this line
                                are treated as page footer and repeat on every page in multi-page
                                dynamic table scenarios. */}
                            {(() => {
                                const fh = parseFloat(this.props.page.FooterZoneHeight) || 60;
                                const ph = parseFloat(this.props.page.height);
                                if (!ph || fh <= 0) return null;
                                const lineY = ph - fh;
                                return (
                                    <>
                                        <svg
                                            style={{
                                                position: 'absolute',
                                                left: 0,
                                                top: lineY,
                                                width: this.props.page.width,
                                                height: 1,
                                                overflow: 'visible',
                                                pointerEvents: 'none',
                                                zIndex: 1
                                            }}
                                        >
                                            <line
                                                x1="0" y1="0"
                                                x2={this.props.page.width} y2="0"
                                                stroke="#b84a8a"
                                                strokeWidth="1"
                                                strokeDasharray="5 4"
                                                opacity="0.6"
                                            />
                                        </svg>
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: lineY - 14,
                                                right: 6,
                                                fontSize: '10px',
                                                color: '#b84a8a',
                                                fontFamily: 'Raleway, Arial',
                                                pointerEvents: 'none',
                                                zIndex: 1,
                                                opacity: 0.75,
                                                fontStyle: 'italic'
                                            }}
                                        >
                                            Footer Zone ({fh}pt)
                                        </div>
                                    </>
                                );
                            })()}
                            {objects &&
                                Object.keys(objects)
                                    .sort((a, b) => {
                                        // ✅ Z-INDEX SORT: DOM order = z-index order, ki stacking garantili çalışsın
                                        const za = (objects[a] && objects[a].properties && objects[a].properties.Zindex) || 0;
                                        const zb = (objects[b] && objects[b].properties && objects[b].properties.Zindex) || 0;
                                        return za - zb;
                                    })
                                    .map(object => {
                                    const obj = objects[object];
                                    if (obj.PageId === this.props.pageid) {
                                        switch (obj.type) {
                                            case 'TextBox':
                                                obj.jpg = "";
                                                return <Default
                                                    context={obj} id={object} key={object}
                                                    onMouseDown={(e) => this.setElementClientPos(e)}
                                                    handleDoubleClick={t => this.onClick(obj)}
                                                    OpenProperties={e => this.props.OpenProperties(e)}
                                                    RemoveIconScale={this.props.scaleNumber}
                                                    GridSize={this.props.GridSize}
                                                />;
                                            case 'Slider':
                                                obj.jpg = "";
                                                return <Default
                                                    context={obj} id={object} key={object}
                                                    onMouseDown={(e) => this.setElementClientPos(e)}
                                                    handleDoubleClick={t => this.onClick(obj)}
                                                    OpenProperties={e => this.props.OpenProperties(e)}
                                                    RemoveIconScale={this.props.scaleNumber}
                                                    GridSize={this.props.GridSize}
                                                />;
                                            case 'Barcode':
                                                obj.jpg = "";
                                                return <Default
                                                    context={obj} id={object} key={object}
                                                    onMouseDown={(e) => this.setElementClientPos(e)}
                                                    handleDoubleClick={t => this.onClick(obj)}
                                                    OpenProperties={e => this.props.OpenProperties(e)}
                                                    RemoveIconScale={this.props.scaleNumber}
                                                    GridSize={this.props.GridSize}
                                                />;
                                            case 'Word':
                                                return <Default context={obj} id={object} key={object}
                                                                onMouseDown={(e) => this.setElementClientPos(e)}
                                                                OpenProperties={e => this.props.OpenProperties(e)}
                                                                RemoveIconScale={this.props.scaleNumber}
                                                                GridSize={this.props.GridSize}
                                                />;
                                            case 'Picture':
                                                return <Default context={obj} id={object} key={object}
                                                                onMouseDown={(e) => this.setElementClientPos(e)}
                                                                OpenProperties={e => this.props.OpenProperties(e)}
                                                                RemoveIconScale={this.props.scaleNumber}
                                                                GridSize={this.props.GridSize}
                                                />;
                                            case 'Signature':
                                                return <Default context={obj} id={object} key={object}
                                                                onMouseDown={(e) => this.setElementClientPos(e)}
                                                                OpenProperties={e => this.props.OpenProperties(e)}
                                                                RemoveIconScale={this.props.scaleNumber}
                                                                GridSize={this.props.GridSize}
                                                />;
                                            case 'Rectangle':
                                                return <Default context={obj} id={object} key={object}
                                                                onMouseDown={(e) => this.setElementClientPos(e)}
                                                                OpenProperties={e => this.props.OpenProperties(e)}
                                                                RemoveIconScale={this.props.scaleNumber}
                                                                GridSize={this.props.GridSize}
                                                />;
                                            case 'Lines':
                                                return <Default context={obj} id={object} key={object}
                                                                onMouseDown={(e) => this.setElementClientPos(e)}
                                                                OpenProperties={e => this.props.OpenProperties(e)}
                                                                RemoveIconScale={this.props.scaleNumber}
                                                                GridSize={this.props.GridSize}
                                                />;
                                            case 'Ellipse':
                                                return <Default context={obj} id={object} key={object}
                                                                onMouseDown={(e) => this.setElementClientPos(e)}
                                                                OpenProperties={e => this.props.OpenProperties(e)}
                                                                RemoveIconScale={this.props.scaleNumber}
                                                                GridSize={this.props.GridSize}
                                                />;
                                            case 'Table':
                                                return <TableElement context={obj} id={object} key={object}
                                                                onMouseDown={(e) => this.setElementClientPos(e)}
                                                                OpenProperties={e => this.props.OpenProperties(e)}
                                                                RemoveIconScale={this.props.scaleNumber}
                                                                GridSize={this.props.GridSize}
                                                />;
                                            case 'Chart':
                                                return <ChartElement context={obj} id={object} key={object}
                                                                onMouseDown={(e) => this.setElementClientPos(e)}
                                                                handleDoubleClick={t => this.onClick(obj)}
                                                                OpenProperties={e => this.props.OpenProperties(e)}
                                                                RemoveIconScale={this.props.scaleNumber}
                                                                GridSize={this.props.GridSize}
                                                />;
                                            default:
                                                return null;
                                        }
                                    }
                                })}
                            {paneNumber}
                        </div>
                    </SelectableGroup>
                </div>
            </div>
        );
    }
}

const mapStateToProp = state => ({
    objects: state.appReducers.objects,
    activeElement: state.appReducers.activeElement
});
export default connect(
    mapStateToProp,
    {
        addToScene,
        addToSceneBulk,
        dropElement,
        dropElementBulk,
        dropElementAll,
        changeProperties,
        changePropertiesById,
        changePropertiesById3,
        changePropertiesRange,
        removeAllDragElements,
        addToDragElements,
        addToDragElementsAll,
        makeElementActive
    }
)(withAlert()(withRouter(Editor)));

export function Welcome() {
    alert(7779);
}
